import { transformAddress } from 'data/transformers/address';
export const transformPaymentsIdentityDocumentFile = file => ({
  identifier: file.identifier,
  uploadNote: file.upload_note
});
export const transformPaymentsIdentityDocumentConfiguration = document => ({
  files: document.files.map(file => transformPaymentsIdentityDocumentFile(file)),
  title: document.title,
  type: document.type,
  maximumFileSize: document.maximum_file_size,
  mediaTypes: document.media_types
});
export const transformPaymentstIdentityDocumentInfo = _ref => {
  let {
    title,
    description
  } = _ref;
  return {
    title,
    description
  };
};
export const transformDocumentFieldConfiguration = documentFieldConfigurations => {
  return {
    field: documentFieldConfigurations.field,
    group: documentFieldConfigurations.group,
    hint: documentFieldConfigurations.hint,
    options: documentFieldConfigurations.options.map(transformPaymentsIdentityDocumentConfiguration),
    info: documentFieldConfigurations.info ? transformPaymentstIdentityDocumentInfo(documentFieldConfigurations.info) : null
  };
};
export const transformDocumentFieldConfigurations = documentFieldConfigurations => documentFieldConfigurations.map(transformDocumentFieldConfiguration);
export const transformPaymentsIdentityConfiguration = _ref2 => {
  let {
    payments_identity
  } = _ref2;
  return {
    firstName: payments_identity.first_name,
    lastName: payments_identity.last_name,
    birthdate: payments_identity.birthdate,
    ssnSerial: payments_identity.ssn_serial,
    personalIdNumber: payments_identity.personal_id_number,
    status: payments_identity.status,
    requiredFields: payments_identity.required_fields,
    address: payments_identity.address && transformAddress(payments_identity.address) || null,
    agreementHint: payments_identity.agreement_hint,
    businessAddress: payments_identity.business_address && transformAddress(payments_identity.business_address),
    registrationNumber: payments_identity.registration_number,
    accountType: payments_identity.account_type,
    documentFieldConfigurations: transformDocumentFieldConfigurations(payments_identity.document_field_configurations),
    verificationFailures: payments_identity.verification_failures && [...payments_identity.verification_failures],
    statusMessage: payments_identity.status_message,
    statusNote: payments_identity.status_note
  };
};